import { css } from '@linaria/core';
import { ellipsis } from 'polished';
import { breakpoints, theming } from 'styles/utils';
export const wrapper = "omponents__Search__Search_styles_ts-wrapper-w2pbxvu";
export const placeholderEllipsis = "omponents__Search__Search_styles_ts-placeholderEllipsis-p18lhvz4";
export const searchInput = "omponents__Search__Search_styles_ts-searchInput-s10oz954";
export const searchIcon = "omponents__Search__Search_styles_ts-searchIcon-slgeh3w";
export const closeIcon = "omponents__Search__Search_styles_ts-closeIcon-c1u703wk";

require("./Search.styles.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./Search.styles.ts");